import React, { Component, Fragment } from 'react';
import Radio from '@material-ui/core/Radio';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

export default class ColorRadio extends Component {
  render() {
    return (
      <div className="mobile-duties__colors d-flex flex-column">
        <h2>رنگ ها</h2>
        <div className="mobile-duties__colors--text">فکر می کنید این ظیفه شما نیاز به یک یادداشت دارد ؟ آن را در قسمت زیر وارد کنید</div>
        <div className="mobile-duties__colors--list d-flex">
          {this.props.colors.map((item) => (
            <Colors item={item} setColor={this.props.setColor} key={item.id} />
          ))}
        </div>
      </div>
    )
  }
}

function Colors(props) {
  return (
    <Fragment>
      <Radio icon={<FiberManualRecordIcon style={{ color: props.item.color, width: 27, height: 25 }} />} checked={props.item.checked} checkedIcon={<CheckCircleIcon style={{ color: props.item.color, width: 23, height: 22 }} />} name="radio" onChange={() => props.setColor(props.item.name, props.item.id)} />
    </Fragment>
  );
}